module.exports = __webpack_public_path__ + "static/media/tell me.00ddb44f.mp3";